<template>
  <component
    :is="stepComponent">
  </component>
</template>

<script setup>

import { reactive, computed, ref, defineExpose, onMounted } from 'vue'

import Step1 from "@/components/builder/products/laundries/TypeAndLayout.vue";
import LaundryStep2 from "@/components/builder/products/laundries/laundry/WallSpace.vue";
import LaundryStep3 from "@/components/builder/products/laundries/laundry/Sections.vue";
import LaundryStep4 from "@/components/builder/products/laundries/laundry/Design.vue";
import CustomLaundryStep2 from "@/components/builder/products/custom/Details.vue";
import CustomLaundryStep3 from "@/components/builder/products/custom/Design.vue";
import Quote from "@/components/builder/Quote.vue";
import Prepare from "@/components/builder/Prepare.vue";

const comps = {
  Step1,
  LaundryStep2,
  LaundryStep3,
  LaundryStep4,
  CustomLaundryStep2,
  CustomLaundryStep3,
  Quote,
  Prepare,
};

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const stepComponent = computed(() => {
  if (builder.mode == 'quote') return comps['Quote'];
  if (builder.mode == 'prepare') return comps['Prepare'];
  if (builder.step <= 1) return comps[builder.stepComponentName]
  return comps[builder.currentProductHandle + builder.stepComponentName]
})

onMounted(() => {
  console.log('stepComponent', builder.currentProductHandle, builder.stepComponentName);
})

</script>
